import Entity from './entity'
export default class moisture_handlewarning extends Entity<number>{
    handlerOne:string;
    handlerTwo:string;
    hIdTwo:string;
    hContent:string;
    hTime:Date;
    htype:number;
}